var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cs_st grid-container",attrs:{"id":"container"}},[_c('BaseLocation',{attrs:{"current-group-name":"information"}}),_c('div',{staticClass:"section terms_wrap",domProps:{"innerHTML":_vm._s(_vm.privacy)}}),_c('Sidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }